import {ColumnDef} from "@tanstack/react-table"
import {sortableColumnHeader} from "@/components/data-table.tsx"
import {Text} from "@/components/tailwind/text"
import {MemberAddressListItem} from "@/models/member-address-list.ts"

export function createAddressListColumns(): ColumnDef<MemberAddressListItem>[] {
    return [
        {
            accessorKey: "memberNo",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.memberNo", "reports"),
        },
        {
            accessorKey: "lastName",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.lastName", "reports"),
        },
        {
            accessorKey: "firstName",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.firstName", "reports"),
        },
        {
            accessorKey: "salutation",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.salutation", "reports"),
            cell: ({row}) => <Text>{row.original.salutation ?? "-"}</Text>,
        },
        {
            accessorKey: "title",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.title", "reports"),
            cell: ({row}) => <Text>{row.original.title ?? "-"}</Text>,
        },
        {
            accessorKey: "district",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.district", "reports"),
            cell: ({row}) => <Text>{row.original.district ?? "-"}</Text>,
        },
        {
            accessorKey: "postcode",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.postcode", "reports"),
            cell: ({row}) => <Text>{row.original.postcode ?? "-"}</Text>,
        },
        {
            accessorKey: "city",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.city", "reports"),
            cell: ({row}) => <Text>{row.original.city ?? "-"}</Text>,
        },
        {
            accessorKey: "street",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.street", "reports"),
            cell: ({row}) => <Text>{row.original.street ?? "-"}</Text>,
        },
        {
            accessorKey: "sortCode",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.sortCode", "reports"),
            cell: ({row}) => <Text>{row.original.sortCode ?? "-"}</Text>,
        },
        {
            accessorKey: "age",
            header: ({column}) =>
                sortableColumnHeader(column, "addressList.table.headers.age", "reports"),
            cell: ({row}) => <Text>{row.original.age ?? "-"}</Text>,
        },
    ]
}
